import React from 'react';
import translate from 'react-i18next/dist/commonjs/translate';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
    fetchTransactionsPreviewAction,
    selectPreviewTransactionsIsLoading,
    selectPreviewTransactions,
    selectPreviewTransactionsPagination,
    selectPreviewTransactionsFilter
} from '../ducks';
import {
  selectAccountId,
  selectAccountRole,
  selectToken,
} from '../../../features/auth/ducks';
import { accountRoles } from '../../../common/enums';
import { 
    transactionTypes, 
    creditorTransactionTypes, 
    debtorTransactionTypes 
} from '../../../common/enums/transactionTypes';
import { ResponsiveTable, OpenFileLink} from '../../../common/components/data-display';
import { mapFilterToEndpointParams, convertJsonToQueryString } from '../../../common/utils/helpers';
import Table from 'antd/lib/table';
import Slider from 'antd/lib/slider';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import { Row, Col } from 'react-flexbox-grid';
import { currencyFormatter, formatDateTime } from '../../../common/utils/helpers';
import DatePicker from 'antd/lib/date-picker';
import Select from 'antd/lib/select';
import Spin from 'antd/lib/spin';
import { delay } from 'redux-saga';

const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;

const mapStateToProps = state => ({
    isLoading: selectPreviewTransactionsIsLoading(state),
    transactions: selectPreviewTransactions(state),
    pagination: selectPreviewTransactionsPagination(state),
    filter: selectPreviewTransactionsFilter(state),
    accountId: selectAccountId(state),
    role: selectAccountRole(state),
    token: selectToken(state)
});
    
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchTransactionsPreview: fetchTransactionsPreviewAction.request,
        },
        dispatch
    ),
});



@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class PreviewTransactionsList extends React.Component {
    state = {
        filter: {
          VS: "",
          InvestmentNumber: "",
          Amount: [],
          Type: "",
          TransactionDateAt: [],
        }
    }
    
    componentDidMount(){
        const {
            actions,
            accountId,
            filter,
            pagination,
        } = this.props;
        actions.fetchTransactionsPreview({
            accountId,
            options: {
                filter: mapFilterToEndpointParams(filter),
            }
        });
        this.setState({
          filter: this.props.filter
        });
        
    }
    onChange(value, key) {
        const filter = this.state.filter;
        if (['VS','InvestmentNumber'].includes(key)){
          filter.InvestmentNumber="";
          filter.VS="";
        }
        filter[key] = value;
        this.setState({
          ...this.state,
          filter
        });
    }

    handleSubmit = () => {
        const {
            actions,
            accountId,
            pagination,
        } = this.props;
        pagination.current = 1
        actions.fetchTransactionsPreview({
            accountId,
            options: {
                filter: mapFilterToEndpointParams(this.state.filter),
                pagination
            }
        });
    }

    handleTableChange = (pagination) => {
        const { actions, filter, accountId } = this.props;
        actions.fetchTransactionsPreview({
            accountId,
            options: {
                filter: mapFilterToEndpointParams(this.state.filter),
                pagination
            }
        });
    };

    resetFilter = () => {
      this.setState(() => ({
          filter: {
            VS: "",
            InvestmentNumber: "",
            Amount: [],
            Type: "",
            TransactionDateAt: [],
          }
        })
      , () => this.handleSubmit());      
    }
    render() {
        const { 
            t,
            isLoading,
            transactions,
            pagination,
            role,
            token,
            accountId
        } = this.props;

        const {
          filter
        } =this.state;

        return <div className="panel-wrapper">
            <Spin spinning={isLoading} >
              <Row className="filters">
                <Col xs={12} md={3}>
                  <div className="filter-search">
                    <Input
                      placeholder={ (role === accountRoles.CREDITOR) ? t('Číslo investície') : t('Variabilný symbol')}
                      value={(role === accountRoles.CREDITOR ? filter.InvestmentNumber: filter.VS)}
                      onChange={(e) => this.onChange(e.target.value, (role === accountRoles.CREDITOR ? "InvestmentNumber": "VS"))}
                      onPressEnter={this.handleSubmit}
                    />
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <Select
                    placeholder={t('Typ transakcie')}
                    key="Type"
                    value={filter.Type}
                    onChange={(value) => this.onChange(value, "Type")}
                    >
                    <Option key="" value="">
                      {t('Všetky typy')}
                    </Option>
                    {role === accountRoles.CREDITOR && Object.entries(transactionTypes).filter(([key,value]) => creditorTransactionTypes.includes(key)).map(([key, value]) => (
                      <Option key={key} value={key}>
                        {value}
                      </Option>
                    ))}
                    {role === accountRoles.DEBTOR && Object.entries(transactionTypes).filter(([key,value]) => debtorTransactionTypes.includes(key)).map(([key, value]) => (
                      <Option key={key} value={key}>
                        {value}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col xs={12} md={4}>
                  <RangePicker
                    format="DD.MM.YYYY"
                    key="TransactionDateAt"
                    value={filter.TransactionDateAt}
                    onChange={
                      ([dateFrom, dateTo]) => {
                        this.onChange([dateFrom, dateTo], "TransactionDateAt");
                      }
                    }
                  />
                </Col>
                <Col>
                  <Button size="small" onClick={this.handleSubmit} type="primary" icon="search" />
                  &nbsp;
                  <Button size="small" onClick={this.resetFilter} icon="close" />
                </Col>
              </Row>
              <Row className="filters padded ant-form-explain">
                <Col xs={12} sm={12}>
                  <div>
                    <Slider
                        range={true}
                        tipFormatter={currencyFormatter}
                        onChange={(value) => {
                          this.onChange(value, "Amount")
                        }}
                        defaultValue={[0,50000]}
                        min={0}
                        max={50000}
                        step={100}
                        marks={{
                          [0]: <span>{currencyFormatter(0)}</span>,
                          [50000]: <span>{currencyFormatter(50000)}</span>,
                        }}
                      />
                  </div>
                </Col>
              </Row>
              <ResponsiveTable
                dataSource={transactions}
                rowKey={transaction => transaction.id}
                pagination={pagination}
                onChange={this.handleTableChange}
              >
                <Column
                  title={t('Typ transakcie')}
                  dataIndex="Type"
                  key="Type"
                  render={Type => t(transactionTypes[Type])}
                />
                <Column
                  title={t('Dátum transakcie')}
                  dataIndex="TransactionDateAt"
                  key="TransactionDateAt"
                  render={TransactionDateAt => formatDateTime(TransactionDateAt)}
                />
                {role === accountRoles.DEBTOR && <Column
                    title={t('Variabilný symbol')}
                    dataIndex="Payment"
                    key="Payment"
                    render={payment => ((payment.id) ? `${payment.VS}` : '')}
                />}
                {role === accountRoles.CREDITOR && <Column
                    title={t('Investícia')}
                    dataIndex="Investment"
                    key="Investment"
                    render={investment => ((investment.id) ? `${investment.InvestmentNumber}` : '')}
                />}
                <Column
                    title={t('Suma')}
                    dataIndex="Amount"
                    key="Amount"
                    render={amount => currencyFormatter(amount)}
                />
                {role === accountRoles.CREDITOR && <Column 
                    title={t('Od')}
                    dataIndex="Loan"
                    key="Loan"
                    render={ loan => (
                              (loan.id) ? `${loan.accountId}` : '')
                           }
                />}
              </ResponsiveTable>
              {token && (
                <OpenFileLink
                  isButton
                  href={`${process.env.REACT_APP_API_URL}/transactions/${accountId}/transactionsReport?token=${token}&filter[transactionType]=${filter.Type}&filter[dateFrom]=${(filter.TransactionDateAt && filter.TransactionDateAt.length > 0) ? filter.TransactionDateAt[0].startOf('day') : '0'}&filter[dateTo]=${(filter.TransactionDateAt && filter.TransactionDateAt.length > 0) ? filter.TransactionDateAt[1].endOf('day') : '0'}&filter[investmentNumber]=${filter.InvestmentNumber}&filter[variableSymbol]=${filter.VS}`}
                >
                  {t('Export')}
                </OpenFileLink>
              )}
            </Spin>
        </div> ;
    }
}


// WEBPACK FOOTER //
// ./src/features/transactions/components/PreviewTransactionsList.js